<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Usuarios App Admin</span>
                            </li>
                            <li class="active">
                                <span>{{ userId ? 'Editar' : 'Crear' }} usuario app admin</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        {{ userId ? 'Editar' : 'Crear' }} usuario app admin
                    </h2>
                    <small>{{ userId ? 'Editar' : 'Crear' }} usuario app admin</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Usuario
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <i class="pe-7s-user fa-5x text-muted"></i>
                            <p class="m-t-md">
                                <strong>Usuario</strong> tiene acceso a la aplicación de administrador
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label>Usuario *</label>
                                    <custom-input tipo="text" :field="$v.form.username"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Contraseña</label>
                                    <custom-input tipo="text" :field="$v.form.password"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save">Guardar</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import {APP_ADMIN_USER_EDIT, APP_ADMIN_USER_LIST} from "../../router/routes";
import CustomInput from '../common/CustomInput.vue'
import {alphaNum, maxLength, required, requiredIf} from 'vuelidate/lib/validators'
import {profileList} from '../../util/selectOptions'
import AppAdminUserService from '../../services/AppAdminUserService';
import Alert from "../../util/alert";

export default {
    name: APP_ADMIN_USER_EDIT.name,
    props: ['userId'],
    components: {CustomInput},
    data: () => ({
        profiles: profileList,
        hotels: [],
        form: {
            username: null,
            password: null,
        }
    }),
    watch: {
        userId: function () {
            if (this.userId) {
                this.clear();
                this.init(this.userId);
            } else
                this.clear();
        },
    },
    validations: {
        form: {
            username: {alphaNum, required, maxLength: maxLength(45)},
            password: {
                required: requiredIf(function () {
                    return !this.userId;
                })
            },
        }
    },
    methods: {
        async init() {
            try {
                if (this.userId) {
                    const user = (await AppAdminUserService.getUser(this.userId)).data.payload;
                    this.load(user);
                }
            } catch (err) {
                Alert.mensajeError(err.message);
                this.$router.push({path: USER_NEW.route});
            }
        },
        load(user) {
            this.form.username = user.username;
        },
        async save() {
            this.$v.$touch();
            if (this.$v.$error) return;
            const self = this;

            const data = {...self.form};
            try {
                if (self.userId) {
                    const userUpdated = (await AppAdminUserService.updateUser(self.userId, data)).data.payload;
                    self.load(userUpdated);
                    Alert.mensajeExito("Usuario actualizado.");
                    self.$router.push({path: APP_ADMIN_USER_LIST.route});
                } else {
                    await AppAdminUserService.addUser(data);
                    Alert.mensajeExito("Usuario creado");
                    self.clear();
                    self.$router.push({path: APP_ADMIN_USER_LIST.route});
                }
                self.$v.$reset();
            } catch (err) {
                Alert.mensajeError(err.message);
            }
        },
        clear() {
            this.form.username = null;
        }
    },
    mounted() {
        this.init();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/appadminuser/AppAdminUserEditor.vue